export default "__VITE_ASSET__DI83RpDf__"